<template>
    <div class="reset-container">
        <div class="reset-box">
            <h2 class="title">重置密码</h2>
            <h4>请填写您账户绑定的邮箱，我们将向此邮箱中发送观致经销商门户的密码重置链接及说明。</h4>
            <el-form :model="resetForm" :rules="loginRules" ref="ruleLoginForm" class="login-ruleForm">
                <el-form-item prop="account">
                    <el-input v-model="resetForm.account" placeholder="用户名" prefix-icon="el-icon-user"></el-input>
                </el-form-item>
                <el-form-item prop="email">
                    <el-input v-model="resetForm.email" placeholder="邮箱地址" prefix-icon="el-icon-message"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button class="submit-button" type="primary" @keyup.enter.native="submitLoginForm()" @click="submitLoginForm()">提 交
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import apiDataFilter from "../utils/apiDataFilter";
export default {
    data() {
        return {
            resetForm: {
                account: '',
                email: ''
            },
            loginRules: {
                account: [{required: true, message: '请输入用户名', trigger: 'blur'},],
                email: [{required: true, message: '请输邮箱地址', trigger: 'blur'}]
            },
        }
    },
    created() {},
    methods: {
        submitLoginForm() {
            apiDataFilter
            .request({
                api: "reset.sendEmail",
                method: "post",
                data: this.resetForm
            })
            .then((res) => {
                if (res.data.result) {
                    this.$message({
                        message: "密码找回邮件已发送至您的邮箱，请查收！",
                        type: 'success'
                    })
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'warning'
                    })
                }
            })
        },
    } 
}
</script>

<style lang="less" scoped>
.reset-container {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    .reset-box {
        position: absolute;
        top: 144px;
        left: 40%;
        width: 20%;
    } 
    .submit-button {
        width: 80%;
        margin: 0 auto;
        display: block;
        margin-top: 40px;
    }
}
</style>